import React from 'react';
import './ogle.scss';

export default React.memo(({children}) => <div className='ogle'>{children}</div>);